import VisaoGeralPage from "@/Pages/BuscaAtiva/VisaoGeralPage.vue";
import TurmasComIncidenciaPage from "@/Pages/BuscaAtiva/TurmasComIncidenciaPage.vue";
import DetalhesAlunoPage from "@/Pages/BuscaAtiva/DetalhesAlunoPage.vue";
import authService from "@/Services/AuthService";
import store from "@/store";

async function carregarUsuarioAtual() {
  let currentUser = store.getters["Auth/user"];
  if (!currentUser) {
    await authService.syncUserWithStore();
    currentUser = store.getters["Auth/user"];
  }
  return currentUser;
}

function possuiPermissao(currentUser, permissions = []) {
  if (currentUser?.roleName === "super-admin") return true;
  return permissions.some((p) => currentUser?.permissions?.includes(p));
}

async function redirecionarSemPermissaoDeVisualizar(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (!possuiPermissao(currentUser, ["buscaAtiva.visualizar", "buscaAtiva.*"])) {
    return next({ name: "home" });
  }

  return next();
}

export default [
  {
    path: "/busca-ativa/visao-geral",
    name: "buscaAtiva.visaoGeral",
    component: VisaoGeralPage,
    beforeEnter: redirecionarSemPermissaoDeVisualizar,
  },
  {
    path: "/busca-ativa/turmas-com-incidencia",
    name: "buscaAtiva.turmasComIncidencia",
    component: TurmasComIncidenciaPage,
    beforeEnter: redirecionarSemPermissaoDeVisualizar,
  },
  {
    path: "/busca-ativa/casos/:caso_id",
    name: "buscaAtiva.detalhesAluno",
    component: DetalhesAlunoPage,
    beforeEnter: redirecionarSemPermissaoDeVisualizar,
  },
];
